<template>
    <div>
        <br>
        <md-table v-if="classroomData.length > 0" v-model="classroomData" md-sort="name" md-sort-order="asc" md-card md-fixed-header>
            <md-table-toolbar>
                <h1 class="md-title">{{editorMode ? "Editable Classrooms" : "Joined Classrooms"}}</h1>
            </md-table-toolbar>

            <md-table-row slot="md-table-row" slot-scope="{ item }">
                <md-table-cell md-label="Name" md-sort-by="name">
                    <router-link :to="'/classroom/' + item.id + (editorMode ? '' : '?viewer=true')">
                        {{ item.name }}
                    </router-link>
                </md-table-cell>
            </md-table-row>
        </md-table>
        <div v-else>
            <md-empty-state
                v-if="editorMode"
                md-icon="error"
                md-label="No Classrooms"
                md-description="You have not created any classrooms. Use classrooms to create assignments for a group of learners and monitor performance.">
            </md-empty-state>
            <md-empty-state
                v-else
                md-icon="error"
                md-label="No Classrooms Joined"
                md-description="You are not currently a member of any classrooms. To join, please request an invitation link from your classroom adminsitrator.">
            </md-empty-state>
        </div>
        <br>
    </div>
</template>

<script>
    export default {
        props: {
            classroomData: {
                type: Array,
            },
            editorMode: {
                type: Boolean
            }
        },
    }
</script>

<style scoped>
    .md-table >>> .md-table-content {
        height: 300px !important;
    }
</style>
